/* import __COLOCATED_TEMPLATE__ from './project-preview.hbs'; */
import Component from '@glimmer/component';
import { htmlSafe } from '@ember/template';
import clsx from 'clsx';

class ProjectPreview extends Component {
  get classNames() {
    return clsx(
      this.args.class,
      'people-center-my-network-project-preview',
      !this.args.application && 'people-center-my-network-project-preview--empty'
    );
  }

  get projectTitle() {
    return htmlSafe(this.args.application?.title ?? '');
  }

  get lastMessage() {
    return this.args.application?.thread?.lastMessage ?? '';
  }
}

export default ProjectPreview;
